import { createSelector } from '@reduxjs/toolkit';

const selectUserActivityLogs = ({ userActivityLogs }) => userActivityLogs;

export const selectUserActivityLogsFilter = createSelector(
  selectUserActivityLogs,
  ({ filters }) => filters
);
